import { useLanguage } from "../context/LanguageContext";
import { Globe, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const legalContent = {
  es: {
    title: "Aviso Legal",
    backHome: "Volver al inicio",
    sections: [
      {
        title: "1. Datos identificativos",
        content: `En cumplimiento con el deber de información recogido en artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, a continuación se reflejan los siguientes datos:

• Nombre comercial: Global Tech Xpert
• Domicilio: Tarragona, España
• Email de contacto: adm@globaltechxperts.nl
• Teléfono: +34 688 853 678`
      },
      {
        title: "2. Objeto",
        content: `El presente aviso legal regula el uso del sitio web globaltechxpert.com (en adelante, el "Sitio Web"), del que es titular Global Tech Xpert.

La navegación por el Sitio Web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.`
      },
      {
        title: "3. Servicios",
        content: `Global Tech Xpert ofrece servicios de importación de tecnología "llave en mano", especializándose en iPhones y smartphones nuevos y usados. Los servicios incluyen:

• Coordinación de compras con proveedores
• Gestión documental
• Logística e importación
• Facturación UE según estructura acordada
• Seguimiento por hitos hasta la entrega`
      },
      {
        title: "4. Propiedad intelectual e industrial",
        content: `El Sitio Web, incluyendo a título enunciativo pero no limitativo su programación, edición, compilación y demás elementos necesarios para su funcionamiento, los diseños, logotipos, texto y/o gráficos, son propiedad de Global Tech Xpert o, en su caso, dispone de licencia o autorización expresa por parte de los autores.

Todos los contenidos del Sitio Web se encuentran debidamente protegidos por la normativa de propiedad intelectual e industrial.`
      },
      {
        title: "5. Exención de responsabilidades",
        content: `Global Tech Xpert se exime de cualquier tipo de responsabilidad derivada de la información publicada en su Sitio Web siempre que esta información haya sido manipulada o introducida por un tercero ajeno al mismo.

El Sitio Web puede utilizar cookies. Las cookies son pequeños ficheros de texto que se almacenan en el navegador del usuario.`
      },
      {
        title: "6. Modificaciones",
        content: `Global Tech Xpert se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su Sitio Web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados.`
      },
      {
        title: "7. Enlaces",
        content: `En el caso de que en el Sitio Web se dispusiesen enlaces o hipervínculos hacia otros sitios de Internet, Global Tech Xpert no ejercerá ningún tipo de control sobre dichos sitios y contenidos.

En ningún caso Global Tech Xpert asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno.`
      },
      {
        title: "8. Derecho de exclusión",
        content: `Global Tech Xpert se reserva el derecho a denegar o retirar el acceso al Sitio Web y/o los servicios ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que incumplan el presente Aviso Legal.`
      },
      {
        title: "9. Generalidades",
        content: `Global Tech Xpert perseguirá el incumplimiento de las presentes condiciones así como cualquier utilización indebida de su Sitio Web ejerciendo todas las acciones civiles y penales que le puedan corresponder en derecho.`
      },
      {
        title: "10. Legislación aplicable y jurisdicción",
        content: `La relación entre Global Tech Xpert y el usuario se regirá por la normativa española vigente. Todas las disputas y reclamaciones derivadas de este aviso legal se resolverán por los juzgados y tribunales de Tarragona, España.`
      }
    ],
    lastUpdate: "Última actualización: Febrero 2026"
  },
  en: {
    title: "Legal Notice",
    backHome: "Back to home",
    sections: [
      {
        title: "1. Identifying data",
        content: `In compliance with the duty of information contained in Article 10 of Law 34/2002, of July 11, on Information Society Services and Electronic Commerce, the following data is provided:

• Trade name: Global Tech Xpert
• Address: Tarragona, Spain
• Contact email: adm@globaltechxperts.nl
• Phone: +34 688 853 678`
      },
      {
        title: "2. Purpose",
        content: `This legal notice regulates the use of the website globaltechxpert.com (hereinafter, the "Website"), owned by Global Tech Xpert.

Browsing the Website grants the status of user and implies full and unreserved acceptance of each and every provision included in this Legal Notice.`
      },
      {
        title: "3. Services",
        content: `Global Tech Xpert offers turnkey technology import services, specializing in new and used iPhones and smartphones. Services include:

• Purchase coordination with suppliers
• Document management
• Logistics and import
• EU billing according to agreed structure
• Milestone tracking until delivery`
      },
      {
        title: "4. Intellectual and industrial property",
        content: `The Website, including but not limited to its programming, editing, compilation and other elements necessary for its operation, designs, logos, text and/or graphics, are the property of Global Tech Xpert or, where applicable, has a license or express authorization from the authors.

All contents of the Website are duly protected by intellectual and industrial property regulations.`
      },
      {
        title: "5. Disclaimer",
        content: `Global Tech Xpert is exempt from any type of liability derived from the information published on its Website provided that this information has been manipulated or entered by a third party.

The Website may use cookies. Cookies are small text files that are stored in the user's browser.`
      },
      {
        title: "6. Modifications",
        content: `Global Tech Xpert reserves the right to make without prior notice the modifications it deems appropriate on its Website, being able to change, delete or add both the content and services provided through it as well as the way in which they appear presented or located.`
      },
      {
        title: "7. Links",
        content: `In the event that links or hyperlinks to other Internet sites are available on the Website, Global Tech Xpert will not exercise any type of control over said sites and contents.

In no case will Global Tech Xpert assume any responsibility for the contents of any link belonging to a third-party website.`
      },
      {
        title: "8. Right of exclusion",
        content: `Global Tech Xpert reserves the right to deny or withdraw access to the Website and/or the services offered without prior notice, at its own request or that of a third party, to those users who fail to comply with this Legal Notice.`
      },
      {
        title: "9. General",
        content: `Global Tech Xpert will pursue non-compliance with these conditions as well as any improper use of its Website by exercising all civil and criminal actions that may correspond to it by law.`
      },
      {
        title: "10. Applicable law and jurisdiction",
        content: `The relationship between Global Tech Xpert and the user will be governed by current Spanish regulations. All disputes and claims arising from this legal notice will be resolved by the courts of Tarragona, Spain.`
      }
    ],
    lastUpdate: "Last updated: February 2026"
  }
};

export default function LegalNoticePage() {
  const { language } = useLanguage();
  const content = legalContent[language];

  return (
    <div className="min-h-screen bg-[#0A0A0A]">
      {/* Header */}
      <header className="glass border-b border-neutral-800/50 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-orange-500 to-amber-400 flex items-center justify-center shadow-lg">
                <Globe className="w-5 h-5 text-white" />
              </div>
              <span className="font-bold text-lg tracking-tight text-white font-['Outfit']">
                Global Tech Xpert
              </span>
            </Link>
            <Link to="/">
              <Button variant="outline" className="rounded-full border-neutral-700 text-neutral-300 hover:bg-neutral-800 gap-2">
                <ArrowLeft className="w-4 h-4" />
                {content.backHome}
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-4xl font-bold text-white font-['Outfit'] mb-8">{content.title}</h1>
        
        <div className="space-y-8">
          {content.sections.map((section) => (
            <div key={section.title} className="glass rounded-2xl p-6">
              <h2 className="text-xl font-bold text-white mb-4">{section.title}</h2>
              <p className="text-neutral-400 whitespace-pre-line">{section.content}</p>
            </div>
          ))}
        </div>

        <p className="text-neutral-500 text-sm mt-8">{content.lastUpdate}</p>
      </main>

      {/* Footer */}
      <footer className="border-t border-neutral-800 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-neutral-500 text-sm">
          © {new Date().getFullYear()} Global Tech Xpert. Todos los derechos reservados.
        </div>
      </footer>
    </div>
  );
}
